"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nnShareSnapShot = nnShareSnapShot;
const tslib_1 = require("tslib");
const tool_nn_1 = tslib_1.__importDefault(require("@futuweb/tool-nn"));
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const report_1 = require("./report");
let supportShareV3 = false;
if (nnq_1.default.isSupportShareV3()) {
    nnq_1.default.initBridge({}, () => {
        supportShareV3 = true;
    });
}
const pageName = location.pathname;
/**
 * 牛牛分享快照
 * @param dataUrl 分享图片的base64数据
 * @param opt 分享文案配置
 * @param opt.title 分享标题
 * @param opt.desc 分享描述
 * @param opt.link 分享链接
 * @param opt.image 分享图片
 * @param success
 * @param fail
 */
async function nnShareSnapShot(dataUrl, opt = {
    title: '',
    desc: '',
    link: '',
    image: ''
}, success = (...args) => {
    console.log('分享成功', ...args);
}, fail = () => { }) {
    // configSnapshot安卓客户端后续不进行维护
    // 优先使用showDiverseShare方法
    if (supportShareV3) {
        nnq_1.default.showDiverseShare({
            show_type: 3,
            // share_data为必传的占位数据
            disable_channel: ['nnq', 'niuyou', 'chatRoom'],
            enable_channel: [],
            share_data: {
                common_model: {
                    title: opt.title || '',
                    description: opt.desc || '',
                    url: opt.link || '',
                    image_url: opt.image || "https://static.futunn.com/futuhk_common/images/favicon.ico",
                    share_model_list: []
                },
            },
            share_image: {
                images: [
                    {
                        img: dataUrl,
                    },
                ],
            },
        }, function (res = { channel: "" }) {
            const { channel } = res;
            (0, report_1.reportFtEvent)('Share', {
                page_name: pageName,
                channel_name: report_1.CHANNEL_MAP[channel] ? report_1.CHANNEL_MAP[channel] : '404', // 属性值如果为空，上报会异常
            }, 10);
        }, fail);
    }
    else {
        // 配置分享快照
        tool_nn_1.default.configSnapshot({
            type: 'base64',
            data: dataUrl,
            success(res = { channel: "" }) {
                const { channel } = res;
                (0, report_1.reportFtEvent)('Share', {
                    page_name: pageName,
                    channel_name: report_1.CHANNEL_MAP[channel] ? report_1.CHANNEL_MAP[channel] : '404', // 属性值如果为空，上报会异常
                }, 10);
                success(res);
            },
            fail,
        });
        setTimeout(() => {
            tool_nn_1.default.showSnapshotShare(opt);
        }, 3000);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzaGFyZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQXVCQSwwQ0E0RUM7O0FBbkdELHVFQUFrQztBQUNsQyw0RUFBNEM7QUFDNUMscUNBQXNEO0FBQ3RELElBQUksY0FBYyxHQUFHLEtBQUssQ0FBQztBQUMzQixJQUFJLGFBQUcsQ0FBQyxnQkFBZ0IsRUFBRSxFQUFFLENBQUM7SUFDekIsYUFBRyxDQUFDLFVBQVUsQ0FBQyxFQUFFLEVBQUUsR0FBRyxFQUFFO1FBQ3BCLGNBQWMsR0FBRyxJQUFJLENBQUM7SUFDMUIsQ0FBQyxDQUFDLENBQUM7QUFDUCxDQUFDO0FBQ0QsTUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLFFBQVEsQ0FBQztBQUduQzs7Ozs7Ozs7OztHQVVHO0FBQ0ksS0FBSyxVQUFVLGVBQWUsQ0FDakMsT0FBZSxFQUNmLEdBQUcsR0FBRztJQUNGLEtBQUssRUFBRSxFQUFFO0lBQ1QsSUFBSSxFQUFFLEVBQUU7SUFDUixJQUFJLEVBQUUsRUFBRTtJQUNSLEtBQUssRUFBRSxFQUFFO0NBQ1osRUFDRCxVQUFVLENBQUMsR0FBRyxJQUFXLEVBQUUsRUFBRTtJQUN6QixPQUFPLENBQUMsR0FBRyxDQUFDLE1BQU0sRUFBRSxHQUFHLElBQUksQ0FBQyxDQUFDO0FBQ2pDLENBQUMsRUFDRCxJQUFJLEdBQUcsR0FBRyxFQUFFLEdBQUcsQ0FBQztJQUVoQiw2QkFBNkI7SUFDN0IseUJBQXlCO0lBQ3pCLElBQUksY0FBYyxFQUFFLENBQUM7UUFDakIsYUFBRyxDQUFDLGdCQUFnQixDQUNoQjtZQUNJLFNBQVMsRUFBRSxDQUFDO1lBQ1oscUJBQXFCO1lBQ3JCLGVBQWUsRUFBRSxDQUFDLEtBQUssRUFBRSxRQUFRLEVBQUUsVUFBVSxDQUFDO1lBQzlDLGNBQWMsRUFBRSxFQUFFO1lBQ2xCLFVBQVUsRUFBRTtnQkFDUixZQUFZLEVBQUU7b0JBQ1YsS0FBSyxFQUFFLEdBQUcsQ0FBQyxLQUFLLElBQUksRUFBRTtvQkFDdEIsV0FBVyxFQUFFLEdBQUcsQ0FBQyxJQUFJLElBQUksRUFBRTtvQkFDM0IsR0FBRyxFQUFFLEdBQUcsQ0FBQyxJQUFJLElBQUksRUFBRTtvQkFDbkIsU0FBUyxFQUFFLEdBQUcsQ0FBQyxLQUFLLElBQUksNERBQTREO29CQUNwRixnQkFBZ0IsRUFBRSxFQUFFO2lCQUN2QjthQUNKO1lBQ0QsV0FBVyxFQUFFO2dCQUNULE1BQU0sRUFBRTtvQkFDSjt3QkFDSSxHQUFHLEVBQUUsT0FBTztxQkFDZjtpQkFDSjthQUNKO1NBQ0osRUFDRCxVQUFVLEdBQUcsR0FBRyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUU7WUFDM0IsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUN4QixJQUFBLHNCQUFhLEVBQ1QsT0FBTyxFQUNQO2dCQUNJLFNBQVMsRUFBRSxRQUFRO2dCQUNuQixZQUFZLEVBQUUsb0JBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsb0JBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxFQUFFLGdCQUFnQjthQUN0RixFQUNELEVBQUUsQ0FDTCxDQUFDO1FBQ04sQ0FBQyxFQUNELElBQUksQ0FDUCxDQUFDO0lBQ04sQ0FBQztTQUFNLENBQUM7UUFDSixTQUFTO1FBQ1QsaUJBQUUsQ0FBQyxjQUFjLENBQUM7WUFDZCxJQUFJLEVBQUUsUUFBUTtZQUNkLElBQUksRUFBRSxPQUFPO1lBQ2IsT0FBTyxDQUFDLEdBQUcsR0FBRyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUU7Z0JBQ3pCLE1BQU0sRUFBRSxPQUFPLEVBQUUsR0FBRyxHQUFHLENBQUM7Z0JBQ3hCLElBQUEsc0JBQWEsRUFDVCxPQUFPLEVBQ1A7b0JBQ0ksU0FBUyxFQUFFLFFBQVE7b0JBQ25CLFlBQVksRUFBRSxvQkFBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxvQkFBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLEVBQUUsZ0JBQWdCO2lCQUN0RixFQUNELEVBQUUsQ0FDTCxDQUFDO2dCQUNGLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQTtZQUNoQixDQUFDO1lBQ0QsSUFBSTtTQUNQLENBQUMsQ0FBQztRQUVILFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDWixpQkFBRSxDQUFDLGlCQUFpQixDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQzlCLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQTtJQUNaLENBQUM7QUFDTCxDQUFDIn0=